enum ExActions {
  LOGIN = "login",
  LOGOUT = "logout",
  UPDATE_USER = "updateUser",
  SEPETE_DONATION_VE_DETAIL_EKLE = "sepeteDonationVeDetailEkle",
  SEPETI_ONAYLA = "sepetiOnayla",
  SEPETI_TEMIZLE = "sepetiTemizle",
  SEPETI_DUZENLE = "sepetiDuzenle",
  UPDATE_SEPET = "updateSepet",
  SEPETTEN_DONATION_VE_DETAIL_SIL = "sepettenBagisDetayiSil",
  SEPETTEKI_DONATION_DETAILI_DUZENLE = "sepettenBagisDetayiDuzenle",

  UPDATE_NOTIF = "updateNotif",
  READ_NOTIF = "readNotif",
}

enum ExMutations {
  LOGOUT = "logOut",
  SET_USER = "setUser",
  SET_AUTH = "setAuth",
  SEPETE_EKLE = "sepeteEkle",
  SEPETE_DONATION_VE_DETAIL_EKLE = "sepeteDonationEkle",
  SEPETE_DONATION_DETAIL_EKLE = "sepeteDonationDetailEkle",
  DONATION_DETAIL_DUZENLE = "donationDetailDuzenle",
  SEPET_SIL = "sepetSil",
  SET_SEPET = "setSepet",

  SET_NOTIF = "setNotif",
}

export { ExActions, ExMutations };
